export function moveBg() {
	
	$(window).on("load", () => {
		if ( $("body").hasClass("no-touch") ) {
			let element = $(".moving-bg");
			
			element.each(function (i, item) {
				let followX = 0;
				let followY = 0;
				let x = 0;
				let y = 0;
				let friction = 1 / 30;
				
				$(window).on("mousemove", function (e) {
					
					let mouseX = Math.max(-100, Math.min(100, $(window).width() / 2 - e.clientX));
					let mouseY = Math.max(-100, Math.min(100, $(window).height() / 2 - e.clientY));
					
					followX = (20 * mouseX) / 100;
					followY = (10 * mouseY) / 100;
					
					x += (followX - x) * friction;
					y += (followY - y) * friction;
					
					let translate = "translate(" + x + "px, " + y + "px) scale(1.1)";
					
					$(item).css("transform", translate);
				});
			});
		}
	});
}


// WEBPACK FOOTER //
// ./assets/js/modules/moving-bg.js